import {
  DownArrowOutlined,
  BentArrowBottomLeftOutlined,
  UpArrowOutlined,
} from "@toddle-edu/ds-icons";
import React from "react";
import { useI18n } from "Hooks";
import classes from "./Footer.scss";

const KeyNameComp = props => {
  const { icon: Icon } = props;
  return (
    <span className={classes.keyNameChamp}>
      <Icon className={classes.icon} />
    </span>
  );
};

const Footer = props => {
  const { t } = useI18n(["common"]);

  return (
    <div className={classes.container}>
      <div className={classes.navigator}>
        <div className={classes.navigatorIcon}>
          <KeyNameComp icon={UpArrowOutlined} />
          <KeyNameComp icon={DownArrowOutlined} />
        </div>
        <div className={classes.navigateText}>{t("common:to_navigate")}</div>
      </div>
      <div className={classes.enter}>
        <KeyNameComp icon={BentArrowBottomLeftOutlined} />
        <div className={classes.enterText}>{t("common:to_select")}</div>
      </div>
    </div>
  );
};

export default Footer;
